import { render, staticRenderFns } from "./CompanyEditDefault.vue?vue&type=template&id=291e431c&"
import script from "./CompanyEditDefault.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('291e431c')) {
      api.createRecord('291e431c', component.options)
    } else {
      api.reload('291e431c', component.options)
    }
    module.hot.accept("./CompanyEditDefault.vue?vue&type=template&id=291e431c&", function () {
      api.rerender('291e431c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditDefault.vue"
export default component.exports